import { Route, Routes } from "react-router";
import { Error } from "@/pages/Error";
import { Index } from "@/pages/Index";
import { Policy } from "@/pages/Policy.tsx";

/**
 * Main application
 * @retruns {ReactNode}
 * @constructor
 */
function App() {

  return (
    <div className={"app"}>
      <Routes>
        <Route path={"/"} element={<Index />} />
        <Route path={"/policy"} element={<Policy />} />
        <Route path={"*"} element={<Error />} />
      </Routes>
    </div>
  );
}

export default App;
